import { render, staticRenderFns } from "./insert.vue?vue&type=template&id=04d4369c"
import script from "./insert.vue?vue&type=script&lang=js"
export * from "./insert.vue?vue&type=script&lang=js"
import style0 from "./insert.vue?vue&type=style&index=0&id=04d4369c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports